/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'

import React, { useRef } from 'react'
import { useInView } from 'framer-motion'

export function InViewDiv({ children, ...props }: { children: React.ReactNode } & any) {
  const containerRef = useRef<HTMLDivElement>(null)
  const isInView = useInView(containerRef, { once: true, amount: 0.4 })

  return (
    <div ref={containerRef} {...props}>
      {isInView ? children : null}
    </div>
  )
}
